import React, { Component } from 'react';

import { Blur, Spinner } from 'components'

class Loading extends Component {

    shouldComponentUpdate ( nextProps, nextState ) {
        return nextProps.show !== this.props.show || nextProps.children !== this.props.children;
    }

    render () {
        return (
            <Blur show="true" theme="light">
                <Spinner theme="light" />
            </Blur>
        )
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/organisms/Loading/index.js